export default __webpack_public_path__ + "static/media/D_05_05_bg.fff95558.mp4";